<Page>
    <Navbar title="Photo Browser" />
  

    <Block strong>
      <p>Photo Browser supports 2 default themes - default Light (like in previous examples) and Dark theme. Here is a Dark theme examples:</p>
  
      
      <p>
        {#await promise}
            <p>loading...</p>
        {:then data}
                <PhotoBrowser photos={data} theme="dark" bind:this={standaloneDark} />
        {:catch error}
            <p>Oh no: {error}</p>
        {/await}
        
      </p>
  
    </Block>
  </Page>
    
  
  
  <script>
    import {Page, Navbar, Block, Row, Col, PhotoBrowser, Button} from 'framework7-svelte';
    import { getPredictedOverpasses } from "../../../tools/service/dates";

  
    let standalone;
    let popup;
    let page;
  
    let standaloneDark;
    let popupDark;
    let pageDark;
    let promise = getPredictedOverpasses({ name: "today" });

    const handleClick = () => {
        promise = getPredictedOverpasses({ name: "today" });
    }

    let photos = [
    ];
    console.log('photos:', photos);
    console.log('photos service:', promise);

  
  </script>